// Sdílené primitivy pro finanční mřížkové tabulky (AOP vrstvy).
// Dřív byly `th` třída a `sticky` factory duplikované v každé vrstvě — a `th` se
// navíc lišila velikostí (13px vs 12px). Tady je jeden zdroj.

// Jednotná třída hlavičkové buňky — typografie převzatá z Výsledovky
// (10,5 px bold uppercase). Vodorovný padding zůstává užší než tam: měsíční
// sloupce mají 112 px a px-3 by čísla zbytečně utáhl.
//
// `sticky top-0` drží hlavičku při svislém scrollu (tabulka teď scrolluje uvnitř
// karty na výšku stránky). z-20 ji drží nad tělem; zamrzlé levé sloupce dostávají
// z-index 30 inline z makeSticky, takže roh (sticky top+left) zůstává navrchu.
export const TH = 'px-2 py-2.5 text-[10.5px] font-bold uppercase tracking-wide sticky top-0 z-20';

// Factory pro styl sticky (zamrzlého) levého sloupce.
//   LEFT      – mapa kumulativních offsetů { klíč: px }
//   borderKey – klíč posledního fixního sloupce (dostane pravý oddělovač)
//   aktivni   – volitelně podmnožina klíčů, které mají opravdu zamrznout;
//               ostatní se chovají jako běžné buňky
//
// Podmnožina je tu kvůli užším displejům: zamrzlý blok má napříč vrstvami
// 400–708 px, což na notebooku sežere většinu šířky a na měsíce nezbude místo.
// Pod prahem proto zamrzne jen sloupec s názvem — ten stačí k orientaci.
export function makeSticky(LEFT, borderKey, aktivni = null) {
    const akt = aktivni ? aktivni.filter(k => k in LEFT) : null;
    const hranice = akt && akt.length ? akt[akt.length - 1] : borderKey;
    return (key, z, bg) => {
        if (akt && !akt.includes(key)) return { background: bg };
        return {
            position: 'sticky', left: LEFT[key], zIndex: z, background: bg,
            ...(key === hranice ? { borderRight: '2px solid var(--border-default)' } : {}),
        };
    };
}
